/* eslint-disable import/prefer-default-export */
export const baseUrl = process.env.NODE_ENV === 'development' ? '/applemango' : '';



// WEBPACK FOOTER //
// ./src/config/index.js